export default "/_next/static/images/c5ee3216d44a662ec4f491ea339dd58d.png";